<template>
    <KvTable
        :items="items"
    />
</template>
<script>
import {mapGetters} from 'vuex';
import KvTable from '@/components/Table/kvTable';
import {
  _PROGRESS_TIME_RANGE,
  _START_TIME_RANGE,
  _DATETIME_FORMAT,
  _DATE_FORMAT,
} from "../../../../Table/static";
import _API from '../../../../../api';

export default {
  components: {
    KvTable,
  },
  props: [
    'eventProps',
  ],
  data() {
    const item = [
      {
        index: 0,
        keyTitle: this.$t('status.date'),
        keyType: 'SingleDateInput',
        class: '',
        keyRange: [],
        componentOptions: {
          minDate: new Date(),
          maxDate: null,
          popoverVisibility: 'focus',
          popoverDirection: 'bottom'
        },
        values: this.eventProps ? this.moment(this.eventProps.start).toDate() : undefined
      },
      {
        index: 1,
        keyTitle: this.$t('rehabilitation.start_time'),
        keyType: 'SelectBox',
        class: '',
        keyRange: this.setRange(this.eventProps ? this.moment(this.eventProps.start).format(_DATE_FORMAT) : undefined, this.getScheduleList()),
        values: this.eventProps?.startTime ? _START_TIME_RANGE.filter(startTimeRange => {
          return this.eventProps.startTime === startTimeRange.value
        }) : null
      },
      {
        index: 2,
        keyTitle: this.$t('RMC.schedule_progress_time'),
        keyType: 'UnitSelectBox',
        class: '',
        keyRange: _PROGRESS_TIME_RANGE,
        values: this.eventProps?.expectProgressTime ? _PROGRESS_TIME_RANGE.filter(progressTimeRange => {
          return this.eventProps.expectProgressTime === progressTimeRange.value
        }) : null
      },
      // {
      //     index: 3,
      //     keyTitle: '테스트중',
      //     keyType: 'ButtonSelectBox',
      //     class: '',
      //     keyRange: '',
      //     values: ''
      // }
    ];
    return {
      items: item,
      value01: this.eventProps ? this.moment(this.eventProps.start).format(_DATE_FORMAT) : undefined,
    }
  },
  mounted() {
    const param = {
      startDatetime: this.moment.tz(this.moment(this.value01).format('YYYY-MM-DD'), this._TIME_ZONE).format(),
      endDatetime: this.moment.tz(this.moment(this.value01).format('YYYY-MM-DD'), this._TIME_ZONE).add({h: 24}).format()
    };
    let list = [];
    // 등록 스케줄 API
    const schedule = _API.SCHEDULE.getAllScheduleByRangeForClinic(param);
    schedule.then((r) => {
      r.data.scheduleList.map((item) => {
        if (item.isAppointed || (!item.isAppointed && item.seqMedicalRelation !== 0)) {
          list.push(item);
        }
      })

      this.items[1].keyRange = this.setRange(this.value01, list);
    })
  },
  methods: {
    ...mapGetters(['getScheduleList']),
    getValue() {
      return {
        date: this.moment(this.items[0].values).format(_DATETIME_FORMAT),
        startTime: Array.isArray(this.items[1].values) ? this.items[1].values[0].value : this.items[1].values.value,
        progressTime: Array.isArray(this.items[2].values) ? this.items[2].values[0].value : this.items[2].values.value
      }
    },
    setRange(newData, scheduleList) {
      let newRange = [];
      let list = [];

      if (newData !== undefined) {
        const nowDate = this.moment(new Date()).format(_DATE_FORMAT);

        if (newData === nowDate) {
          const nowTime = Number(this.moment(new Date()).format('HHmm'));

          newRange = _START_TIME_RANGE.filter(item => Number(item.value.replace(':', '')) > nowTime);
        } else {
          newRange = _START_TIME_RANGE;
        }

        scheduleList.map((item) => {
          let diffMinute = this.moment(item.scheduleExpectProgressTime, 'HH:mm:ss').minute();
          diffMinute = diffMinute === 0 ? 60 : diffMinute;
          let cnt = diffMinute / 15;

          if (this.eventProps?.seqSchedule === item?.seqSchedule)
            cnt = 1;

          for (let i = 0; i < cnt; i++) {
            list.push(Number(this.moment(item.scheduleExpectStartDatetime)
                .add(i * 15, 'minutes')
                .format('HHmm')))
          }
        })
      } else {
        newRange = _START_TIME_RANGE;
      }

      return newRange.map((item) => {
        return {
          ...item,
          disabled: list.includes(Number(item.value.replace(':', '')))
        };
      });
    }
  },
  watch: {
    items: {
      deep: true,
      handler(items) {
        this.value01 = this.moment(items[0].values).format(_DATE_FORMAT);
      }
    },
    value01: {
      deep: true,
      async handler(newData, oldData) {
        if (newData !== null && newData !== oldData) {
          const param = {
            startDatetime: this.moment.tz(this.moment(newData).format('YYYY-MM-DD'), this._TIME_ZONE).format(),
            endDatetime: this.moment.tz(this.moment(newData).format('YYYY-MM-DD'), this._TIME_ZONE).add({h: 24}).format()
          };
          let list = [];
          // 등록 스케줄 API
          const schedule = _API.SCHEDULE.getAllScheduleByRangeForClinic(param);
          await schedule.then((r) => {
            r.data.scheduleList.map((item) => {
              if (item.isAppointed || (!item.isAppointed && item.seqMedicalRelation !== 0)) {
                list.push(item);
              }
            })
          })

          this.items[1].keyRange = this.setRange(newData, list);
        }
      }
    },
  },
}
</script>